import { Component, input } from '@angular/core';

@Component({
  selector: 'rfa-label',
  standalone: true,
  templateUrl: './rfa-label.component.html',
  styleUrls: ['./rfa-label.component.scss'],
})
export class RfaLabelComponent {
  public readonly id = input<string>();
  public readonly label = input.required<string>();
  public readonly showOptional = input<boolean>(false);

  protected optionalText = '(optioneel)';
}
